import React from "react";
import TextInput from "../inputs/TextInput";

const Text = ({
	register,
	error,
	placeholder = "Enter text",
	required = false,
	className = "",
	id,
	field,
}) => {
	return (
		<TextInput
			label=""
			placeholder={placeholder}
			required={required}
			error={error}
			// descriptionBelow="Start typing your address and select from the suggestions"
			hideLabel={true}
			{...register(id, {
				required: required
					? `${field.title || "This field"} is required`
					: false,
			})}
			name={id}
		/>
	);
};

export default Text;
